export const convertAndSortKeys = (obj) => {
    const result = {};
    const keys = Object.keys(obj);

    // Convert keys from YYYY-MM to MM-YYYY
    const convertedKeys = keys.map(key => {
        const [year, month] = key.split("-");
        return { originalKey: key, convertedKey: `${month}-${year}` };
    });

    // Sort keys based on the original YYYY-MM format
    convertedKeys.sort((a, b) => {
        if (a.originalKey < b.originalKey) return -1;
        if (a.originalKey > b.originalKey) return 1;
        return 0;
    });

    // Create the result object with sorted keys
    convertedKeys.forEach(({ originalKey, convertedKey }) => {
        result[convertedKey] = obj[originalKey];
    });

    return result;
};